module.exports = __webpack_public_path__ + "static/media/quote-buddha-mouth-fr.59be6060.png";